import { FC } from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { IOtherAuthorBook } from '@/interfaces/bookDetail.interface';
import { displayNoneImgOnError } from '@/helpers/helpers';
import styles from './SimilarBooks.module.scss';
import { IBookShortDetailOtherAuthorBook } from '@/interfaces/bookShortDetail.interface';

interface ISimilarBooks {
  books: IBookShortDetailOtherAuthorBook[];
}

const SimilarBooks: FC<ISimilarBooks> = ({ books }) => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    initialSlide: 0,
    variableWidth: true,
    slidesToScroll: 1,
    slidesToShow: 5,
    swipe: false,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          swipe: true,
          arrows: false,
          touchThreshold: 1000000,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 530,
        settings: {
          swipe: true,
          arrows: false,
          slidesToShow: 3,
          slidesToSwipe: 2,
          touchThreshold: 1000000,
          swipeToSlide: true,
        },
      },
    ],
  };

  return (
    <>
      <div className={styles.similarBook}>
        <h2 className={styles.similarBook__title}>Другие книги автора:</h2>

        {books.length > 5 ? (
          <div className={styles.booksSlider}>
            <Slider {...settings} className={styles.booksSlider__wrap}>
              {books.map((book) => {
                const { title, id } = book.book;

                return (
                  <div key={`${id}`} className={styles.scrollCard}>
                    <div className={`${styles.similarBook__item} ${styles.similarBook__item_slider}`}>
                      <div className={styles.similarBook__imgWrap}>
                        <Link prefetch={false} className={styles.similarBook__imgLink} href={`/avtor/${book.author?.alias}/${book.alias}`}>
                          <img className={styles.similarBook__img} src={`${DEV_ABSOLUTE_URL}/covers/${book.book.external_id}.jpg`} width="110" height="140" alt={title} onError={displayNoneImgOnError} />
                        </Link>
                      </div>

                      <Link prefetch={false} className={styles.similarBook__link} href={`/avtor/${book.author?.alias}/${book.alias}`}>
                        <span className={styles.similarBook__name}>{title}</span>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        ) : (
          <div className={styles.similarBook__list}>
            {books.map((book, i) => {
              const { title, id } = book.book;

              return (
                <div key={`${id}-other-${i}`} className={styles.similarBook__item}>
                  <div className={styles.similarBook__imgWrap}>
                    <Link prefetch={false} className={styles.similarBook__imgLink} href={`/avtor/${book.author?.alias}/${book.alias}`}>
                      <img className={styles.similarBook__img} src={`${DEV_ABSOLUTE_URL}/covers/${book.book.external_id}.jpg`} width="110" height="140" alt={title} onError={displayNoneImgOnError} />
                    </Link>
                  </div>

                  <Link prefetch={false} className={styles.similarBook__link} href={`/avtor/${book.author?.alias}/${book.alias}`}>
                    <span className={styles.similarBook__name}>{title}</span>
                  </Link>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default SimilarBooks;
